export const PROXY = "http://posting.quilatonlawoffice.com";
